<script lang="ts" module>
	export interface VideoCardProps {
		dataCy: string;
		duration: string;
		src: string;
		title: string;
		class?: string;
		description: string;
		href: string;
		onclick?: () => void;
		variant?: 'dark' | 'light';
		children?: import('svelte').Snippet;
		classes?: {
			imageContainerClass?: string;
			textContainerClass?: string;
		};
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { MediaCard } from '../MediaCard';
	import { Txt } from '../Txt';
	import { Duration } from './Duration';
	import { PlayFab } from './PlayFab';
	import { isTallVideoCardTitle } from './utils/isTallVideoCardTitle/isTallVideoCardTitle';

	let props: VideoCardProps = $props();
	let dataCyPrefix = $derived(`${props.dataCy}-video-media-card`);
	let titleHeight: number | undefined = $state();
</script>

<MediaCard
	dataCy={`${props.dataCy}-video`}
	src={props.src}
	href={props.href}
	onclick={props.onclick}
	variant={props.variant}
	alt={props.title}
	class={props.class}
	classes={props.classes}
>
	{#snippet imageOverlay()}
		<Duration dataCy={dataCyPrefix}>
			{props.duration}
		</Duration>
		<PlayFab />
	{/snippet}

	{#snippet title()}
		<div>
			<div bind:clientHeight={titleHeight}>
				<Txt
					class={classNames('mb-2 line-clamp-2', {
						'text-gray-0': props.variant === 'dark'
					})}
					variant="h6"
					dataCy={`${dataCyPrefix}-title`}
				>
					{props.title}
				</Txt>
			</div>
		</div>
	{/snippet}

	{#snippet description()}
		{#if props.description}
			<Txt
				class={classNames({
					'text-gray-500': props.variant === 'dark',
					'line-clamp-2': isTallVideoCardTitle(titleHeight),
					'line-clamp-3': !isTallVideoCardTitle(titleHeight)
				})}
				variant="body2"
				dataCy={`${dataCyPrefix}-description`}
			>
				{props.description}
			</Txt>
		{/if}

		{#if props.children}
			{@render props.children()}
		{/if}
	{/snippet}
</MediaCard>
